export enum GroupHistoryInformationType {
  GroupInfo = "GroupInfo",
  AddressInfo = "AddressInfo",
  UserInfo = "UserInfo",
  PaymentInfo = "PaymentInfo",
  GroupGroupTypeInfo = "GroupGroupTypeInfo",
  GroupContractInfo = "GroupContractInfo",
}
